import { createRouter, createWebHistory } from "vue-router";
import HomeView from "@/profile/views/HomeView.vue";
import ContractView from "@/profile/views/ContractView.vue";
import TerminationView from "@/profile/views/TerminationView.vue";
import ChangePass from "@/profile/views/ChangePass.vue";
import ProlongationView from "@/profile/views/ProlongationView.vue"
import ConstructorView from "@/profile/views/ConstructorView.vue"
import ProjectView from "@/profile/views/ProjectView.vue";
// import OptionsView from "@/profile/views/OptionsView.vue";
// import LoadView from "@/profile/views/LoadView.vue";
import LoginView from "@/profile/views/auth/LoginView.vue";
import SigninView from "@/profile/views/auth/SigninView.vue";
import ForgotView from "@/profile/views/auth/ForgotView.vue";
import ServicesView from "@/profile/views/ServicesView.vue";
import LivingStatementView from "@/profile/views/LivingStatementView.vue";
import RedemptionAmountsView from "@/profile/views/RedemptionAmountsView.vue";
import InsuranceClaimStatementView from "@/profile/views/InsuranceClaimStatementView";
import ContractsView from "@/profile/views/ContractsView.vue";
import TaxCertificateView from "@/profile/views/TaxCertificate View.vue";

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  {
    path: "/contracts",
    name: "contracts",
    component: ContractsView,
  },
  {
    path: "/contract/:id",
    name: "contract",
    component: ContractView,
    props: true,
  },
  {
    path: "/contract-for-b2b/:id/:token",
    name: "contractForB2B",
    component: ContractView,
    props: true,
  },
  {
    path: "/termination/:id",
    name: "termination",
    component: TerminationView,
    props: true,
  },
  { // Смена временного пароля
    path: "/changepass",
    name: "changepass",
    component: ChangePass,
  },
  {
    path: "/prolongation",
    name: "prolongation",
    component: ProlongationView,
  },
  {
    path: "/constructor",
    name: "constructor",
    component: ConstructorView,
  },
  {
    path: "/project",
    name: "project",
    component: ProjectView,
  },
  // { // Смена пароля
  //   path: "/options",
  //   name: "options",
  //   component: OptionsView
  // },
  // {
  //   path: "/load/:urltok",
  //   name: "load",
  //   component: LoadView,
  //   props: true,
  // },
  {
    path: "/login",
    name: "login",
    component: LoginView,
  },
  {
    path: "/signin",
    name: "signin",
    component: SigninView,
  },
  {
    path: "/forgot",
    name: "forgot",
    component: ForgotView,
  },
  {
    path: "/services",
    name: "services",
    component: ServicesView,
  },
  {
    path: "/living/:id",
    name: "living",
    component: LivingStatementView,
    props: true,
  },
  {
    path: "/ra/:id",
    name: "ra",
    component: RedemptionAmountsView,
    props: true,
  },
  {
    path: "/insclaim/:id",
    name: "insclaim",
    component: InsuranceClaimStatementView,
    props: true,
  },
  {
    path: "/taxcert/:id",
    name: "taxcert",
    component: TaxCertificateView,
    props: true,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});


export default router;
